firebird.factory('videoTalkerLayoutService', [
    '$rootScope',
    '$window',
    '$timeout',
    'logService',
    'attendeeListService',
    'configService',
    'videoGlobalService',
    function ($rootScope, $window, $timeout, logService, attendeeListService, configService, videoGlobalService) {
        const logger = logService.createLoggerWithSource('videoTalkerLayoutService');
        var service = {
            initialize: initialize
        };

        var self, $scope;

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // active talker based layout: null ("none"), "spotlight", "border", "filter", "zoomin", "highlight" or "auto".
            // If auto, then use spotlight if no content, and border for content.
            // Can be changed in audio/video settings (in local storage) or by URL parameter.
            // If set to ?talkerLayout=none, it becomes null and disabled.
            self.talkerLayout = 'auto';
            self.talkerActive = null;

            // whether we are display screen or not? used by talkerLayout == 'auto'
            self.hasScreenDisplay = false;

            self.initTalkerLayout = initTalkerLayout;
            self.updateTalkerLayout = updateTalkerLayout;
            self.isAttendeeTalking = isAttendeeTalking;

            self.updateTalkerTimeout = 2000;
            self.updateTalkerTimer = null;

            self.updateTalkerLayoutSpotlight = updateTalkerLayoutSpotlight;
        }

        // update state from URL parameter.
        function initTalkerLayout() {
            var talkerLayout = configService.getClientValue('talkerLayout') || 'auto'; // default is auto
            self.talkerLayout = talkerLayout == 'none' ? null : talkerLayout;

            if (self.talkerLayout) {
                $window.$('#videoroom-videos').attr('talkerLayout', self.talkerLayout);
            }
        }

        function updateTalkerLayout() {
            var found = null; // avoid setting multiple to spotlight in one call.

            (attendeeListService.getAttendeeList() || []).forEach(function (attendee) {
                if (attendee) {
                    var div = self.getVideoElement(attendee.attendantId, true);

                    if (div) {
                        var isTalking = self.isAttendeeTalking(attendee);
                        self.setVideoTalking(div, isTalking);
                        if (isTalking && self.layoutPage && !self.isCompactMode) {
                            // bring in by flip first.
                            if (self.onLayoutPageUpdateTalker(div.getAttribute('user')) === false) {
                                return; // no slot found to bring the talker.
                            }
                        }

                        // trigger spotlight view for this new active talker if
                        // in spotlight param or auto param with no screen display and with spotlight existing.
                        // and is different than previous active talker, and is not self user.

                        if (self.isCompactMode) {
                            self.compactUpdateTalkerLayout(isTalking, attendee.attendantId);
                        } else {
                            if (
                                !found &&
                                (self.talkerLayout == 'spotlight' ||
                                    (self.talkerLayout == 'auto' && !self.hasScreenDisplay && !!self.maxvideo)) &&
                                isTalking &&
                                self.talkerActive != attendee.attendantId &&
                                attendee.attendantId != self.attendantId
                            ) {
                                found = attendee.attendantId;
                                self.updateTalkerLayoutSpotlight(attendee.attendantId);
                            }
                        }
                    }
                }
            });
        }

        // this function is borrowed from attendeeCtrl.js - TODO: refector to remove duplicate.
        // TODO: ideally attendee.isTalking should be reset if other criteria fails (like device permission, active)
        function isAttendeeTalking(attendee) {
            if (!attendee || !attendee.isTalking) {
                return false;
            }

            var attendeeMuted = attendee.isSelfMuted ? true : false;
            var audioAllowed = attendee.devicePermissions && attendee.devicePermissions.audioAllowed ? true : false;
            //TODO: After next mobile release (version 2.1.5),
            //we can remove the check for isMobileAppUser
            if ((attendee.deviceConnections || attendee.isPhoneUser) && !attendee.isMobileAppUser) {
                if (attendee.connectivity.pstnState == 'connected') {
                    return true;
                }
                var audioDeviceConnected = attendee.deviceConnections.audioConnected ? true : false;
                return audioAllowed && audioDeviceConnected && !attendeeMuted;
            } else {
                //Old flow, for backwards compability
                return audioAllowed && !attendeeMuted;
            }
        }

        function updateTalkerLayoutSpotlight(activeAttendeeId) {
            if (self.updateTalkerTimer) {
                $timeout.cancel(self.updateTalkerTimer);
                self.updateTalkerTimer = null;
            }

            self.updateTalkerTimer = $timeout(function () {
                self.updateTalkerTimer = null;

                var existingAttendee = self.findAttendee(self.talkerActive);
                var activeAttendee = self.findAttendee(activeAttendeeId);
                var div = self.getVideoElement(activeAttendeeId, true);

                if (
                    div &&
                    div != self.maxvideo &&
                    (!existingAttendee ||
                        (!self.isAttendeeTalking(existingAttendee) && self.isAttendeeTalking(activeAttendee)))
                ) {
                    logger.log(
                        'videoroomCtrl switching spotlight talker ' + self.talkerActive + '=>' + activeAttendeeId
                    );
                    self.talkerActive = activeAttendeeId;

                    if (!self.layoutPage || self.layoutPageData.layout == 'spotlight') {
                        self.toggleVideoFullsize(div);

                        // dispaly only a specific video
                    }
                }
            }, self.updateTalkerTimeout);

            self.updateTalkerTimer = null;
        }
    }
]);
